export const getters = {
  productIndexingList: ({ productIndexingList }) => productIndexingList,
};
